import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TableColumn } from '@siemens/ngx-datatable/lib/types/table-column.type';
import { UserDto, UserPoolDto } from '@clearing-hub/common';
import { NgTemplateOutlet } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../service/user.service';
import { ColumnMode } from '@siemens/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'fxch-import-users',
  templateUrl: './import-users.component.html',
  styleUrls: ['./import-users.component.scss']
})
export class ImportUsersComponent implements OnInit {

  @ViewChild('importUserTmpl', { static: true }) importUserTmpl: TemplateRef<NgTemplateOutlet>;
  @ViewChild('usernameTmpl', { static: true }) usernameTmpl: TemplateRef<NgTemplateOutlet>;
  @ViewChild('emailTmpl', { static: true }) emailTmpl: TemplateRef<NgTemplateOutlet>;

  @ViewChild('importCellTmpl', { static: true }) importCellTmpl: TemplateRef<NgTemplateOutlet>;
  @ViewChild('emailCellTmpl', { static: true }) emailCellTmpl: TemplateRef<NgTemplateOutlet>;
  @ViewChild('usernameCellTmpl', { static: true }) usernameCellTmpl: TemplateRef<NgTemplateOutlet>;

  userPools: Array<UserPoolDto>;

  columns: Array<TableColumn>;

  ColumnMode = ColumnMode;

  users: Array<UserDto>;
  importForm: FormGroup;
  cognitoForm: FormGroup;

  userPoolId: string;
  isImportButtonDisabled: boolean;

  bit = true;

  constructor(private readonly activatedRoute: ActivatedRoute,
              private readonly fb: FormBuilder,
              private readonly toastr: ToastrService,
              private readonly userService: UserService) {
  }

  ngOnInit(): void {
    this.userPools = this.activatedRoute.snapshot.data['preload'];
    this.cognitoForm = this.fb.group({
      userPoolId: new FormControl(null, [Validators.required])
    });
    this.initTable();
  }

  initUsers() {
    if (this.cognitoForm.invalid) {
      return;
    }
    this.userService.getUsersFromSpecificUserPool(this.cognitoForm.value.userPoolId).subscribe((users) => {
      this.users = users;
      this.userPoolId = this.cognitoForm.value.userPoolId;
      this.initUserForm();
      this.refresh();
    });
  }

  initUserForm() {
    this.importForm = this.fb.group(
      this.users.reduce((acc, user) => {
        acc[user.id] = new FormControl(false);
        return acc;
      }, {})
    );

    this.setImportIsDisabled();
    this.importForm.valueChanges.subscribe(() => {
      this.setImportIsDisabled();
    });
  }

  setImportIsDisabled() {
    this.isImportButtonDisabled = Object.keys(this.importForm.controls).filter(k => this.importForm.controls[k].value).length <= 0;
  }

  initTable() {
    this.columns = [
      {
        headerTemplate: this.importUserTmpl,
        cellTemplate: this.importCellTmpl,
        name: 'Import user',
        width: 150,
        maxWidth: 150,
        sortable: false
      },
      {
        headerTemplate: this.usernameTmpl,
        cellTemplate: this.usernameCellTmpl,
        name: 'Username',
        prop: 'username',
      },
      {
        headerTemplate: this.emailTmpl,
        cellTemplate: this.emailCellTmpl,
        name: 'Email',
        prop: 'email',
      }
    ];
  }

  importUsers() {
    if (this.importForm.invalid) {
      return;
    }
    this.userService.importUsers({
      userIds: Object.keys(this.importForm.value).filter(k => this.importForm.value[k]),
      userPoolId: this.userPoolId
    }).subscribe({
      next: () => {
        this.toastr.success('Users successfully imported');
      },
      error: (err) => {
        console.log(err);
        this.toastr.error(err.error.message, undefined, {
          enableHtml: true,
          disableTimeOut: true,
          toastClass: 'override-toastr-message ngx-toastr'
        });
      }
    })
  }

  refresh() {
    this.bit = false;
    setTimeout(() => {
      this.bit = true;
    }, 10);
  }

  onTableSorting() {
    this.refresh();
  }
}
